import getStore from '../store/Store';
import { action } from 'satcheljs/lib/legacy';
import { ObservableMap } from 'mobx';
import getUrlOverrides from '../utils/overrides/getUrlOverrides';
import { setLogicalRing } from 'owa-config/lib/getLogicalRing';
import calculateLogicalRing from '../utils/calculateLogicalRing';
import { getLocalStorageOverrides } from '../utils/overrides/localStorageOverrides';

export const FEATURES_QUERYSTRING_PARAMETER_NAME = 'features';

export interface InitializeState {
    featureFlags: ObservableMap<string, boolean>;
    defaultFlags: ObservableMap<string, boolean>;
}

export default action('initializeFeatureFlags')(function initializeFeatureFlags(
    location: Pick<Location, 'search'>,
    flagsFromService?: string[]
) {
    const enabledFlagsFromService: string[] = flagsFromService || [];

    // Apply defaults from the service
    enabledFlagsFromService.forEach(featureName => {
        getStore().defaultFlags.set(featureName.toLowerCase(), true);
        getStore().featureFlags.set(featureName.toLowerCase(), true);
    });

    // Apply overrides from local storage
    const localStorageOverrides = getLocalStorageOverrides();
    for (const featureName of Object.keys(localStorageOverrides)) {
        getStore().featureFlags.set(featureName.toLowerCase(), localStorageOverrides[featureName]);
    }

    // Apply overrides from URL parameters
    const queryOverrides = getUrlOverrides(FEATURES_QUERYSTRING_PARAMETER_NAME, location);
    for (const featureName of Object.keys(queryOverrides)) {
        getStore().featureFlags.set(featureName.toLowerCase(), queryOverrides[featureName]);
    }

    setLogicalRing(calculateLogicalRing());
});
